/** @file buildInfo: what Vite injected at build (git SHA, build time, contracts tag, Babylon version). */

/** The editor build: `sha` is the short git SHA, `at` an ISO time, `contracts` the frozen-contracts tag, `babylon` its version. */
export type BuildInfo = { sha: string; at: string; contracts: string; babylon: string };

/** Set by `vite.config.ts` `define`; absent under Vitest and in the dev pages that do not go through the config. */
declare const __POSE3D_BUILD__: BuildInfo | undefined;

const UNKNOWN: BuildInfo = { sha: 'dev', at: '', contracts: 'unknown', babylon: 'unknown' };

/** The injected build info, or `{ sha: 'dev', ... }` when nothing was injected. */
export function buildInfo(): BuildInfo {
  return typeof __POSE3D_BUILD__ === 'undefined' ? UNKNOWN : { ...UNKNOWN, ...__POSE3D_BUILD__ };
}
